class ReactFetchAbortError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ReactFetchAbortError'
  }
}

export default ReactFetchAbortError
